import {useContext, useEffect, useState} from "react";
import {
  BaSeButton,
  BaSeDatePicker,
  BaSeHeading6,
  BaSeInput,
  BaSeOptionPicker,
  BaSeParagraph,
  BaSePopupButton,
} from "@base/react";
import {eventTag, formatCurrency, formatFloat, getCurrentCompany, getDateTomorrow,} from "../../../../services/utils";
import logoTrophy from "../../../../assets/images/trophy.svg";
import logoResult from "../../../../assets/images/icons/logo-results.svg";
import MyChart from "../../../../components/chart";
import ModalDefault from "../../../../components/modals/modal-default";
import Textarea from "../../../../components/textarea";
import AccordionModal from "../../../../components/accordion-modal";
import ModalResult from "../../../../components/modals/modal-result";
import BodyResult from "../body-result";
import BtnResult from "../../../../components/btn-result";
import ApiPlannings from "../../../../services/planning";
import {AppContext} from "../../../../context/app";

const popoverSold = {
  direction: "left",
  alertSize: 255,
  iconProps: {
    color: "#005EB8",
    size: 16,
  },
  title: "Variação geral das quantidades vendidas",
  message: (
    <span
      dangerouslySetInnerHTML={{
        __html: `Ao inserir um valor percentual neste campo, você simula uma variação geral nas quantidades vendidas, impactando os indicadores de resultado apresentados neste painel.

Use esta ferramenta para ajustar as vendas percentualmente e explorar cenários financeiros variados. Observe como todos os indicadores são afetados, permitindo que você planeje estrategicamente.

Essa simulação pode orientar suas ações empreendedoras, ajudando a definir metas alcançáveis por meio do aumento das vendas <strong>(RECEITA TOTAL)</strong>.

Por exemplo, é possível calcular o aumento nas vendas necessário para atingir uma meta específica de lucro.
  `,
      }}
    />
  ),
  type: "popover",
};
const popoverPrices = {
  direction: "left",
  alertSize: 255,
  iconProps: {
    color: "#005EB8",
    size: 16,
  },
  title: "Valor investimento fixo",
  message: (
    <span
      dangerouslySetInnerHTML={{
        __html: `
Ao inserir um valor percentual neste campo, você simula uma variação geral nos preços de venda, impactando os indicadores de resultado deste painel.

Use este campo para ajustar percentualmente os preços de venda e explorar diferentes cenários financeiros. Observe como todos os indicadores são atualizados, permitindo um planejamento estratégico.

Essas simulações ajudam a definir metas viáveis por meio do ajuste dos preços de venda.

Por exemplo, você pode calcular o aumento médio nos preços necessário para atingir uma meta específica de lucro. Contudo, lembre-se de que os preços praticados são fortemente influenciados por fatores de mercado.

Para fundamentar seu planejamento financeiro, observe o mercado e os preços de produtos e/ou serviços similares ou substitutos. Acompanhe a concorrência e ajuste as estratégias conforme necessárias.

<strong>Nota</strong>: Este campo ajusta apenas os preços de venda dos produtos e/ou serviços comercializados pela empresa, não suas quantidades.`,
      }}
    />
  ),
  type: "popover",
};
const workingCapital = `
Lembre-se: você pode formar seu Capital de Giro com recursos próprios ou financiados. <br /> <br/>

Este campo indica o montante necessário para sustentar as operações da empresa. <br /> <br/>

<strong>Atenção</strong>: Ajustes nos percentuais de aumento dos preços de venda ou das quantidades vendidas impactam diretamente esse valor, alterando a necessidade total de capital de giro.
`;

const goalPlan = `
  Encare o seu planejamento como uma meta a ser alcançada. <br /> <br />
  Para isso, preencha este campo com a data na qual você estima que o seu negócio terá alcançado os resultados projetados neste plano.
`;
const periods = () => {
  const periods = [];
  const maxPeriods = 120;

  for (let p = 1; p <= maxPeriods; p++) {
    periods.push({
      id: p,
      label: `${p} ${p > 1 ? "meses" : "mês"}`,
    });
  }

  return periods;
};

const eventRecommendations = {
  name: "recommendations",
  category: "recommendations",
  action: "click",
}

const api = ApiPlannings();
const Results = ({
  data,
  isDisabled,
  onChange,
  results,
  goToFLow,
  event,
  idPlanning,
}) => {
  const structureData = {
    VGdQV: data?.VGdQV || 0,
    VGdPV: data?.VGdPV || 0,
    VGdQV_just: data?.VGdQV_just || "",
    VGdPV_just: data?.VGdPV_just || "",
    goal_date: data?.goal_date ? new Date(data?.goal_date) : null,
  };
  const { companies } = useContext(AppContext)
  const company = getCurrentCompany(companies)

  const [form, setForm] = useState(structureData);
  const [currentPeriod, setCurrentPeriod] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalOnSubmit, setShowModalOnSubmit] = useState(false);
  const [dataRecommendations, setDataRecommendations] = useState([]);
  

  const recommendations = async () => {
    try {
      const {data} = await api.getRecommendations(idPlanning)
      setDataRecommendations( data || [])
      eventTag(eventRecommendations?.name, eventRecommendations?.category, "submit", "Buscar recomendações")
    } catch (error) {
      console.warn(error);
    }
  };

  useEffect(() => {
    recommendations();

    // eslint-disable-next-line
  }, [results]);

  useEffect(() => {
    if (
      results &&
      Object.values(results?.fluxgraph).length === 0 &&
      !isDisabled
    ) {
      setShowModal(true);
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (form.goal_date !== structureData.goal_date)
      onChange("goal_date", form.goal_date);
    // eslint-disable-next-line
  }, [form.goal_date]);

  const maskPercentage = (event) => {
    const value = event.target.value;
    const hasNegativeSign = value.includes("-");

    const onlyDigits = value
      .replace("-", "")
      .split("")
      .filter((s) => /\d/.test(s))
      .join("")
      .padStart(3, "0");

    const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2);

    let valorFloat = parseFloat(digitsFloat);

    if (hasNegativeSign) {
      valorFloat = Math.max(valorFloat * -1, -100.0);
    } else {
      valorFloat = Math.min(valorFloat, 100.0);
    }

    let formatedValue = formatCurrency(Math.abs(valorFloat).toFixed(2));

    if (hasNegativeSign) {
      formatedValue = `-${formatedValue}`;
    }

    event.target.value = formatedValue;
  };

  const [isOpen, setIsOpen] = useState(false);

  const modalResultOpen = () => {
    eventTag(eventRecommendations?.name, eventRecommendations?.category, eventRecommendations?.action, "Abrir recomendações")
    setIsOpen(true);
  };

  const modalResultClose = () => {
    eventTag(eventRecommendations?.name, eventRecommendations?.category, eventRecommendations?.action, "Fechar recomendações")
    setIsOpen(false);
  };

  return (
    <div className="step results">
      <ModalDefault
        show={showModal}
        callBackClose={() => setShowModal(false)}
        title="Atenção! Notas técnicas"
        square
      >
        <div className="notes-modal">
          <BaSeParagraph>
            <span>NOTA TÉCNICA 1:</span> <br />
            Se os dados lançados nesta calculadora estiverem incoerentes com a
            realidade da empresa, o planejamento elaborado não deverá ser
            utilizado para basear decisões estratégicas e nem balizar as
            negociações relacionadas a contratação de crédito.
          </BaSeParagraph>
          <br />
          <BaSeParagraph>
            <span>NOTA TÉCNICA 2:</span> <br />O dimensionamento da Necessidade
            de Capital de Giro, contido nesta calculadora, visa fundamentar
            decisões sobre política de prazos e investimentos em capital de giro
            e utiliza estimativas para valores como vendas, prazos, custos e
            estoque. Se estas estimativas estiverem incoerentes com a realidade
            da empresa no mercado, a Necessidade de Capital de Giro, apresentada
            na tela denominada Resultado, não representará, necessariamente, o
            valor a ser pleiteado como crédito em uma instituição financeira
            (banco).
          </BaSeParagraph>
          <br />
          <BaSeParagraph>
            <span>NOTA TÉCNICA 3:</span> <br />O método de dimensionamento da
            Necessidade de Capital de Giro, contido nesta calculadora tem,
            fundamentalmente, caráter orientativo. Visa ampliar a compreensão
            sobre as finanças da empresa e possibilita realizar simulações que
            demostrem como a Necessidade de Capital de Giro muda de valor quando
            variamos as vendas ou os prazos médios de recebimento, de pagamento
            e das mercadorias em estoque.
          </BaSeParagraph>
          <br />
          <BaSeButton value="Fechar" onClick={() => setShowModal(false)} />
        </div>
      </ModalDefault>

      <ModalDefault
        callBackClose={() => setShowModalOnSubmit(false)}
        show={showModalOnSubmit}
        title="Estabeleça sua meta!"
      >
        <BaSeParagraph>
          Para finalizar e baixar o planejamento, por favor preencha a Data da
          meta planejamento na tela de <strong> Resultados.</strong>
        </BaSeParagraph>{" "}
        <br />
        <BaSeButton
          value="Ok"
          onClick={() => setShowModalOnSubmit(false)}
          width="71px"
        />
      </ModalDefault>

      <BaSeHeading6 className="title-result" color="#2E5DE6" isBold>
        Resultado para {data?.title}
      </BaSeHeading6>

      {results ? (
        <>
          <div className="results-and-calculations">
            <div className="results-information">
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph isBold>Receita Total (RT)</BaSeParagraph>
                </span>
                <span className="results-information__value">
                  <BaSeParagraph>
                    R$ {formatCurrency(results?.rt)}
                  </BaSeParagraph>
                </span>
              </div>
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph isBold>Custo Total (CT)</BaSeParagraph>
                </span>
                <span className="results-information__value">
                  <BaSeParagraph>
                    R$ {formatCurrency(results?.ct)}
                  </BaSeParagraph>
                </span>
              </div>
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph isBold>Lucro (L)</BaSeParagraph>
                </span>
                <span
                  className={`results-information__value highlighted ${
                    results?.l?.toLocaleString().length > 15 ? "big-number" : ""
                  }`}
                  style={{
                    backgroundColor: results?.l >= 0 ? "#cfe2fc" : "#F3D8DA",
                  }}
                >
                  <BaSeParagraph
                    color={
                      results?.l === 0
                        ? "#005EB8"
                        : results?.l > 0
                        ? "#008000"
                        : "#BF303C"
                    }
                    isBold
                  >
                    R$ {formatCurrency(results?.l)}
                  </BaSeParagraph>
                </span>
              </div>
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph
                    color={results?.lt >= 0 ? "#2E5DE6" : "#BF303C"}
                    isBold
                  >
                    Lucratividade (%LT)
                  </BaSeParagraph>
                </span>
                <span
                  className={`results-information__value highlighted ${
                    results?.lt?.toLocaleString().length > 15
                      ? "big-number"
                      : ""
                  }`}
                  style={{
                    backgroundColor: results?.lt >= 0 ? "#cfe2fc" : "#F3D8DA",
                  }}
                >
                  <BaSeParagraph
                    color={
                      results?.lt === 0
                        ? "#005EB8"
                        : results?.lt > 0
                        ? "#008000"
                        : "#BF303C"
                    }
                    isBold
                  >
                    {formatCurrency(results?.lt)}%
                  </BaSeParagraph>
                </span>
              </div>
            </div>
            <div className="second-block">
              <div className="second-block-title">
                <img src={logoResult} alt="logo de resultados" />
                <BaSeHeading6 isBold color="#2E5DE6">
                  Entenda os cálculos
                </BaSeHeading6>
              </div>
              <div className="second-block-content">
                <BaSeHeading6 color="#2E5DE6" isBold>
                  Lucro
                </BaSeHeading6>
                <BaSeParagraph>
                  <span>Lucro (L)</span> = Receita Total (RT) - Custo Total (CT)
                </BaSeParagraph>
              </div>
              <div className="second-block-content">
                <BaSeHeading6 color="#2E5DE6" isBold>
                  Lucratividade
                </BaSeHeading6>
                <BaSeParagraph>
                  <span>Lucratividade (%LT)</span> = Lucro (L) / Receita Total
                  (RT)
                </BaSeParagraph>
              </div>
            </div>
          </div>

          <div className="sections-bar light mobile with-top" />

          <div className="results-space">
            <BaSeHeading6 className="title-result" color="#2E5DE6" isBold>
              Investimento
            </BaSeHeading6>
          </div>

          <div className="results-and-calculations special-result">
            <div className="results-information">
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph isBold>Investimento Fixo</BaSeParagraph>
                </span>
                <span className="results-information__value">
                  <BaSeParagraph>
                    R$ {formatCurrency(results.iif)}
                  </BaSeParagraph>
                </span>
              </div>
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph isBold>Capital de Giro Próprio</BaSeParagraph>
                </span>
                <span className="results-information__value">
                  <BaSeParagraph>
                    R$ {formatCurrency(results?.cgp)}
                  </BaSeParagraph>
                </span>
              </div>
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph
                    color={results?.intot >= 0 ? "#2E5DE6" : "#BF303C"}
                    isBold
                  >
                    Investimento Total
                  </BaSeParagraph>
                </span>
                <span
                  className={`results-information__value highlighted ${
                    results?.intot?.toLocaleString().length > 15
                      ? "big-number"
                      : ""
                  }`}
                  style={{
                    backgroundColor:
                      results?.intot >= 0 ? "#cfe2fc" : "#F3D8DA",
                  }}
                >
                  <BaSeParagraph
                    color={
                      results?.intot === 0
                        ? "#005EB8"
                        : results?.intot > 0
                        ? "#008000"
                        : "#BF303C"
                    }
                    isBold
                  >
                    R$ {formatCurrency(results?.intot)}
                  </BaSeParagraph>
                </span>
              </div>
            </div>
            <div className="second-block">
              <div className="second-block-title">
                <img src={logoResult} alt="logo de resultados" />
                <BaSeHeading6 isBold color="#2E5DE6">
                  Entenda os cálculos
                </BaSeHeading6>
              </div>
              <div className="second-block-content">
                <BaSeHeading6 color="#2E5DE6" isBold>
                  Investimento Total
                </BaSeHeading6>
                <BaSeParagraph>
                  <span>Investimento Total</span> = Investimento fixo + Capital
                  de Giro Próprio
                </BaSeParagraph>
              </div>
            </div>
          </div>

          <div className="results-and-calculations special-result">
            <div className="results-information special-results">
              <div className="results-information__data">
                <span className="results-information__info">
                  <BaSeParagraph
                    color={results?.rtm >= 0 ? "#2E5DE6" : "#BF303C"}
                    isBold
                  >
                    Rentabilidade (mensal)
                  </BaSeParagraph>
                </span>
                <span
                  className={`results-information__value highlighted ${
                    results?.rtm?.toLocaleString().length > 15
                      ? "big-number"
                      : ""
                  }`}
                  style={{
                    backgroundColor: results?.rtm >= 0 ? "#cfe2fc" : "#F3D8DA",
                  }}
                >
                  <BaSeParagraph
                    color={
                      results?.rtm === 0
                        ? "#005EB8"
                        : results?.rtm > 0
                        ? "#008000"
                        : "#BF303C"
                    }
                    isBold
                  >
                    {formatCurrency(results?.rtm)}%
                  </BaSeParagraph>
                </span>
              </div>
              <div className="results-information__data no-border">
                <span className="results-information__info">
                  <BaSeParagraph
                    color={results?.pri >= 0 ? "#2E5DE6" : "#BF303C"}
                    isBold
                  >
                    Prazo de Retorno de Investimentos (anual)
                  </BaSeParagraph>
                </span>
                <span
                  className={`results-information__value highlighted ${
                    results?.pri?.toLocaleString().length > 15
                      ? "big-number"
                      : ""
                  }`}
                  style={{
                    backgroundColor: results?.pri >= 0 ? "#cfe2fc" : "#F3D8DA",
                  }}
                >
                  <BaSeParagraph
                    color={
                      results?.pri === 0
                        ? "#005EB8"
                        : results?.pri > 0
                        ? "#008000"
                        : "#BF303C"
                    }
                    isBold
                  >
                    {formatCurrency(results?.pri)}
                  </BaSeParagraph>
                </span>
              </div>
            </div>
            <div className="second-block special">
              <div className="second-block-title">
                <img src={logoResult} alt="logo de resultados" />
                <BaSeHeading6 isBold color="#2E5DE6">
                  Entenda os cálculos
                </BaSeHeading6>
              </div>
              <div className="second-block-content">
                <BaSeHeading6 color="#2E5DE6" isBold>
                  Rentabilidade (Mensal)
                </BaSeHeading6>
                <BaSeParagraph>
                  <span>Rentabilidade</span> = Lucro (L) / Investimento Total
                  (IT)
                </BaSeParagraph>
              </div>
              <div className="second-block-content">
                <BaSeHeading6 color="#2E5DE6" isBold>
                  Prazo de Retorno de Investimentos (Anual)
                </BaSeHeading6>
                <BaSeParagraph>
                  <span>Prazo de Retorno de Investimentos</span> = (Investimento
                  Total (IT) / Lucro (L))/ 12
                </BaSeParagraph>
              </div>
            </div>
          </div>

          <div className="sections-bar light mobile with-top" />

          <div className="results-space">
            <BaSeHeading6 className="title-result" color="#2E5DE6" isBold>
              Capital de giro
            </BaSeHeading6>
          </div>

          <div className="results-and-calculations">
            <div>
              <div className="results-information">
                <div className="results-information__data">
                  <span className="results-information__info">
                    <BaSeParagraph isBold>
                      Necessidade de Capital de Giro
                    </BaSeParagraph>
                  </span>
                  <span className="results-information__value">
                    <BaSeParagraph>
                      R$ {formatCurrency(results?.ncg)}
                    </BaSeParagraph>
                  </span>
                </div>
                <div className="results-information__data">
                  <span className="results-information__info">
                    <BaSeParagraph isBold>
                      Capital de giro próprio
                    </BaSeParagraph>
                  </span>
                  <span className="results-information__value">
                    <BaSeParagraph>
                      R$ {formatCurrency(results?.cgp)}
                    </BaSeParagraph>
                  </span>
                </div>
                <div className="results-information__data">
                  <span className="results-information__info">
                    <BaSeParagraph
                      color={results?.nfcg >= 0 ? "#BF303C" : "#2E5DE6"}
                      isBold
                    >
                      Necessidade de Formação de Capital de Giro
                    </BaSeParagraph>
                    <div className="tooltip-capital">
                      <BaSePopupButton
                        title="Necessidade de Formação de Capital de Giro"
                        type="popover"
                        direction="bottom"
                        message={
                          <span
                            dangerouslySetInnerHTML={{ __html: workingCapital }}
                          />
                        }
                        alertSize={315}
                      />
                    </div>
                  </span>
                  <span
                    className={`results-information__value highlighted ${
                      results?.nfcg?.toLocaleString().length > 15 &&
                      results?.nfcg > 0
                        ? "big-number"
                        : ""
                    }`}
                    style={{
                      backgroundColor:
                        results?.nfcg >= 0 ? "#F3D8DA" : "#cfe2fc",
                    }}
                  >
                    <BaSeParagraph
                      color={
                        results?.nfcg === 0
                          ? "#005EB8"
                          : results?.nfcg > 0
                          ? "#BF303C"
                          : "#008000"
                      }
                      isBold
                    >
                      R${" "}
                      {formatCurrency(results?.nfcg >= 0 ? results?.nfcg : 0)}
                    </BaSeParagraph>
                  </span>
                </div>
              </div>
              {results?.nfcg <= 0 && (
                <span className="message-observation">
                  <BaSeParagraph isThin>
                    Não há necessidade de Formação de Capital de Giro
                  </BaSeParagraph>
                </span>
              )}
            </div>
            <div className="second-block">
              <div className="second-block-title">
                <img src={logoResult} alt="logo de resultados" />
                <BaSeHeading6 isBold color="#2E5DE6">
                  Entenda os cálculos
                </BaSeHeading6>
              </div>
              <div className="second-block-content">
                <BaSeHeading6 color="#2E5DE6" isBold>
                  Necessidade de Formação Capital de Giro
                </BaSeHeading6>
                <BaSeParagraph>
                  <span>Necessidade de Formação de Capital de Giro</span> =
                  Necessidade de Capital de Giro - Capital de Giro Próprio
                </BaSeParagraph>
              </div>
            </div>
          </div>

          <div className="sections-bar light with-top" />

          <AccordionModal
            marginBottom={0}
            canClose={false}
            title="Lembre-se"
            bgColor="#EBE8FF"
          >
            <div className="accordion-block-tip">
              <p>
                Você pode formar seu Capital de Giro com recursos próprios ou
                financiados. <br /> <br />
                Este campo indica o montante necessário para sustentar as
                operações da empresa. <br /> <br /> <strong>
                  Atenção:
                </strong>{" "}
                Ajustes nos percentuais de aumento dos preços de venda ou das
                quantidades vendidas impactam diretamente esse valor, alterando
                a necessidade total de Capital de Giro.
              </p>
            </div>
          </AccordionModal>
        </>
      ) : (
        ""
      )}

      <div style={{ marginBottom: "24px" }} className="bar"></div>

      <BaSeHeading6 className="title-result mobile" color="#2E5DE6" isBold>
        Cenários de alterações de vendas
      </BaSeHeading6>

      <div className="inputs-area">
        <div>
          <BaSeInput
            inputMode="decimal"
            typeInput="tel"
            prefix="% "
            value={form.VGdQV}
            maxLength={10}
            onInput={(e) => {
              maskPercentage(e);
            }}
            onChange={(e) => {
              setForm({ ...form, VGdQV: e });
            }}
            onBlur={(e) => onChange("VGdQV", formatFloat(e.target.value))}
            size="medium"
            placeholder="%"
            label="Variação geral das quantidades vendidas"
            width="100%"
            showHelpButton
            helpButtonProps={popoverSold}
            isDisabled={isDisabled}
          />
          <Textarea
            id="justificativa_1"
            value={form.VGdQV_just}
            setValue={(e) => {
              setForm({ ...form, VGdQV_just: e });
            }}
            onBlur={(e) => onChange("VGdQV_just", e.target.value)}
            isDisabled={isDisabled}
            placeholder="Descreva a justificativa para variação geral das quantidades vendidas"
            label="Justificativa (opcional)"
          />
        </div>
        <div>
          <BaSeInput
            color="default"
            typeInput="tel"
            prefix="% "
            value={form.VGdPV}
            maxLength={10}
            onInput={(e) => {
              maskPercentage(e);
            }}
            onChange={(e) => {
              setForm({ ...form, VGdPV: e });
            }}
            onBlur={(e) => onChange("VGdPV", formatFloat(e.target.value))}
            size="medium"
            placeholder="%"
            label="Variação geral de preços de venda"
            width="100%"
            showHelpButton
            helpButtonProps={popoverPrices}
            isDisabled={isDisabled}
          />
          <Textarea
            id="justificativa_2"
            value={form.VGdPV_just}
            setValue={(e) => {
              setForm({ ...form, VGdPV_just: e });
            }}
            onBlur={(e) => onChange("VGdPV_just", e.target.value)}
            isDisabled={isDisabled}
            placeholder="Descreva a justificativa para variação geral dos preços de venda"
            label="Justificativa (opcional)"
          />
        </div>
      </div>

      <div className="bar"></div>

      {results && Object.values(results?.fluxgraph).length ? (
        <div className="chart-area">
          <div className="wrapper-select">
            <BaSeOptionPicker
              label="Período da projeção"
              width={286}
              values={periods()}
              enableSelectAll={false}
              menuAlwaysIsOpen={false}
              withFilterText={true}
              emptyValueLabel="Selecione"
              maxOptionsSelected={1}
              initialSelectedValuesId={currentPeriod}
              onChange={(values) => {
                setCurrentPeriod(values.map((val) => val.id));
              }}
            />
            {currentPeriod.length ? (
              <button
                className="btn-clear"
                type="button"
                onClick={() => setCurrentPeriod([])}
              >
                Limpar filtro
              </button>
            ) : null}
          </div>
          <div className="chart-area__data">
            <MyChart result={results} period={currentPeriod} />
          </div>
        </div>
      ) : (
        <div className="projected-flow">
          <BaSeParagraph color="#8B99A7">
            Você ainda não tem nenhum Fluxo de Caixa Projetado
          </BaSeParagraph>

          <BaSeButton
            buttonType="button"
            color="#2E5DE6"
            value="Criar Fluxo de Caixa Projetado"
            isDisabled={isDisabled}
            onClick={() => {
              goToFLow();
              eventTag(
                event?.name,
                event?.category,
                event?.action,
                "Criar Fluxo de Caixa Projetado"
              );
            }}
          />
        </div>
      )}

      <div className="bar last"></div>

      <div id="goalDate" className="goal">
        <img src={logoTrophy} alt="goal" />
        <div className="goal__input-area">
          <span style={{ display: "flex" }}>
            <BaSeParagraph>
              Estabeleça uma meta para cumprir o seu planejamento!
            </BaSeParagraph>
            <BaSePopupButton
              title="Estabeleça uma meta para cumprir o seu planejamento!"
              type="popover"
              direction="left"
              message={<span dangerouslySetInnerHTML={{ __html: goalPlan }} />}
              alertSize={300}
            />
          </span>

          <div className="date-picker">
            <BaSeDatePicker
              calendarType="days"
              minDate={getDateTomorrow()}
              startDate={form.goal_date}
              onStartDateChange={(e) =>
                setForm((prevForm) => ({
                  ...prevForm,
                  goal_date: e,
                }))
              }
              placeholder="Selecione sua data"
              label="Data da meta"
              isDisabled={isDisabled}
            />
          </div>
        </div>
      </div>

      <div className="sections-bar light external" />

      <span className="technical-notes">
        <p color="#617385" onClick={() => setShowModal(true)}>
          Relembre as notas técnicas
        </p>
      </span>
              
      {results?.recommendations && dataRecommendations.length > 0 ? <BtnResult callback={modalResultOpen} /> : ""}

      <ModalResult
        show={isOpen}
        callBackClose={modalResultClose}
        title={"Recomendações"}
        enterprise={company?.name || ''}
      >
        <BodyResult data={dataRecommendations} eventRecommendations={eventRecommendations}/>
      </ModalResult>
    </div>
  );
};

export default Results;
